import React from 'react';
import { Redirect } from 'react-router-dom';
import { Auth } from 'aws-amplify'
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import loginImg from '../../img/login.png';
import useAuth from './context/auth';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch',
    },
    padding: '2em',
  },
  cardDiv: {
    boxSizing: 'border-box',
    maxWidth: '410px',
    margin: '0 auto',
    padding: '0 2rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  formDiv: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingTop: '10vh'
  },
  button: {
    backgroundColor: '#006bb6',
    '&:hover': {
      backgroundColor: '#006bb6',
      filter: 'brightness(90%)',
    },
    textTransform: 'none',
    fontWeight: 'bold'
  },
  logoDiv: {
    textAlign: 'center',
  },
  logo: {
    width: '50%',
    marginBottom: '1rem',
  },
}));

const Login = () => {
  const classes = useStyles();
  const { user } = useAuth();

  const redirect = '/';

  const postLogin = () => {
    Auth.federatedSignIn({ customProvider: process.env.REACT_APP_CPMT_COGNITO_IDP })
  }

  if (user) {
    return <Redirect to={redirect} />;
  }

  return (
    <div className={classes.cardDiv}>
      <div className={classes.formDiv}>
        <div className={classes.logoDiv}>
          <img alt="login" src={loginImg} className={classes.logo} />
        </div>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={postLogin}
        >
          Sign in with SAIC
        </Button>
      </div>
    </div>
  );
};

export default Login;
